import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=458b0572&"
import script from "./orders-list.vue.ts?vue&type=script&lang=ts&"
export * from "./orders-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports